// Services
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class SharingService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    // Sharing AJAX Methods
    getSharedItem(urlParams) {
        const url = this.urlsService.getUrl(this.urlsService.SHARING.SHARED_ITEM_COLLECTION, urlParams);
        return this.ajaxService.getDataObserveBody(url);
    }
    postSharedItem(urlParams, postParams) {
        const url = this.urlsService.getUrl(this.urlsService.SHARING.SHARED_ITEM_COLLECTION, urlParams);
        return this.ajaxService.postJsonDataObserveBody(url, postParams);
    }
    putSharedItem(urlParams, putParams) {
        const url = this.urlsService.getUrl(this.urlsService.SHARING.SHARED_ITEM, urlParams);
        return this.ajaxService.putDataObserveBody(url, putParams);
    }
    deleteSharedItem(urlParams) {
        const url = this.urlsService.getUrl(this.urlsService.SHARING.SHARED_ITEM, urlParams);
        return this.ajaxService.deleteDataObserveBody(url);
    }
    // URL Shortener AJAX methods
    getShortenedURL(fullURL) {
        const url = this.urlsService.SHARING.URL_SHORTENER;
        const params = { full_url: fullURL };
        return this.ajaxService.postFormEncodedDataObserveBody(url, params);
    }
    // Private Sharing AJAX Methods
    changeSharedClientGroup(urlParams, postParams) {
        const url = this.urlsService.getUrl(this.urlsService.SHARING.CLIENT_GROUP_CHANGE, urlParams);
        return this.ajaxService.postJsonDataObserveBody(url, postParams);
    }
    // Public Sharing State AJAX Methods
    changePublicSharingState(itemId, itemType, targetState, publicShareGroupId) {
        const url = this.urlsService.getUrl(this.urlsService.SHARING.PUBLIC_SHARING_STATE, { itemId, itemType });
        return this.ajaxService.postFormEncodedDataObserveBody(url, {
            publicSharingState: targetState,
            publicShareGroupId,
        });
    }
    getPublicSharingState(itemId, itemType) {
        const url = this.urlsService.getUrl(this.urlsService.SHARING.PUBLIC_SHARING_STATE, { itemId, itemType });
        return this.ajaxService.getDataObserveBody(url);
    }
}
SharingService.ɵfac = function SharingService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SharingService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
SharingService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SharingService, factory: SharingService.ɵfac, providedIn: 'root' });
